/**
 *
 * 主map天空盒子配置 1.0
 *
 * 功能点:动态配置天空盒子
 * 场景:方案演示
 *
 */
import Vue from "@/main";

/**
 * 天空盒
 * @var lantianSkybox - 蓝天
 * @var qingtianSkybox - 晴天
 * @var wanxiaSkybox - 晚霞
 *
 */
export let lantianSkybox = null;

export let qingtianSkybox = null;

export let wanxiaSkybox = null;

let currSkyBox;

/**
 * 初始化
 * 天空盒
 * @returns { any }
 */
export function skyBoxOnMounted(type = "1", map = Vue.$GLOBAL.map) {
  console.log("初始化天空盒");
  lantianSkybox = new mars3d.GroundSkyBox({
    sources: {
      positiveX: "/img/skybox_near/lantian/Right.jpg",
      negativeX: "/img/skybox_near/lantian/Left.jpg",
      positiveY: "/img/skybox_near/lantian/Front.jpg",
      negativeY: "/img/skybox_near/lantian/Back.jpg",
      positiveZ: "/img/skybox_near/lantian/Up.jpg",
      negativeZ: "/img/skybox_near/lantian/Down.jpg",
    },
  });
  qingtianSkybox = new mars3d.GroundSkyBox({
    sources: {
      positiveX: "/img/skybox_near/qingtian/rightav9.jpg",
      negativeX: "/img/skybox_near/qingtian/leftav9.jpg",
      positiveY: "/img/skybox_near/qingtian/frontav9.jpg",
      negativeY: "/img/skybox_near/qingtian/backav9.jpg",
      positiveZ: "/img/skybox_near/qingtian/topav9.jpg",
      negativeZ: "/img/skybox_near/qingtian/bottomav9.jpg",
    },
  });
  wanxiaSkybox = new mars3d.GroundSkyBox({
    sources: {
      positiveX: "/img/skybox_near/wanxia/SunSetRight.png",
      negativeX: "/img/skybox_near/wanxia/SunSetLeft.png",
      positiveY: "/img/skybox_near/wanxia/SunSetFront.png",
      negativeY: "/img/skybox_near/wanxia/SunSetBack.png",
      positiveZ: "/img/skybox_near/wanxia/SunSetUp.png",
      negativeZ: "/img/skybox_near/wanxia/SunSetDown.png",
    },
  });
  // 默认值
  let defaultSkybox = map.scene.skyBox;
  // 背景色
  let defaultBgColor = map.scene.backgroundColor;

  switch (type) {
    case "0":
      currSkyBox = lantianSkybox;
      break;
    case "1":
      currSkyBox = qingtianSkybox;
      break;
    case "2":
      currSkyBox = wanxiaSkybox;
      break;
    default:
      currSkyBox = lantianSkybox;
      break;
  }
  map.on(mars3d.EventType.postRender, function () {
    const position = map.camera.position;
    const height = Cesium.Cartographic.fromCartesian(position).height;
    if (height < 230000) {
      if (currSkyBox) {
        map.scene.skyBox = currSkyBox;
        map.scene.backgroundColor = Cesium.Color.LIGHTBLUE;
      }
      map.scene.skyAtmosphere.show = false;
    } else {
      let atmosphericRenderingShow = window.sessionStorage.getItem(
        "atmosphericRenderingShow"
      );
      if (defaultSkybox) {
        map.scene.skyBox = defaultSkybox;
        map.scene.backgroundColor = defaultBgColor;
      }
      if (!atmosphericRenderingShow) {
        map.scene.skyAtmosphere.show = true;
      }
    }
  });
}

export function skyBoxToUpdate(type = "1") {
  // console.log("天空盒子", currSkyBox === Vue.$GLOBAL.map.scene.skyBox);
  switch (type) {
    case "0":
      currSkyBox = lantianSkybox;
      break;
    case "1":
      currSkyBox = qingtianSkybox;
      break;
    case "2":
      currSkyBox = wanxiaSkybox;
      break;
    default:
      currSkyBox = lantianSkybox;
      break;
  }
}
